import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://crm-collab-1.preview.emergentagent.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Seo — per-route metadata helper.
 *
 * Defaults reference the SoftwareApplication-shaped meta in public/index.html.
 * Override only what differs for a specific page.
 *
 *   <Seo
 *     title="Pricing — Real Leads CRM"
 *     description="Flat $35/month. No per-seat fees."
 *     path="/pricing"
 *   />
 */
export function Seo({
  title,
  description,
  path = '',
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  type = 'website',
}) {
  const fullUrl = `${SITE_URL}${path.startsWith('/') ? path : '/' + path}`;
  const fullTitle = title || 'Real Leads CRM — Shared Lead Pipeline for Sales Teams';
  const fullDesc = description || 'A modern CRM built around shared leads. Kanban pipeline, AI voice notes, automated follow-ups, email tracking, and team performance dashboards — $35/month.';
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
